import { api } from "../helpers";

export const getLinksList = (param, token) => {
	return api("/youtube/links", "GET", undefined, param, token);
};

export const postLinksMany = (payload, token) => {
	return api("/youtube/links/many", "POST", payload, undefined, token);
};

export const truncateLinks = (payload, token) => {
	return api("/youtube/links/truncate", "DELETE", payload, undefined, token);
};
